import { render, staticRenderFns } from "./BookingComponent.vue?vue&type=template&id=943860ba&scoped=true&"
import script from "./BookingComponent.vue?vue&type=script&lang=ts&"
export * from "./BookingComponent.vue?vue&type=script&lang=ts&"
import style0 from "./BookingComponent.vue?vue&type=style&index=0&id=943860ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943860ba",
  null
  
)

export default component.exports